<template>
	 <router-view :key="$route.fullPath" />
</template>

<style>
/* 全局样式 */
body {
  margin: 0;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  background-color: #f8f9fa;
}
</style>